const languages = [
    {"value":"English","code":"en","default":false},
    {"value":"Deutsch","code":"de","default":false},
    {"value":"Polski","code":"pl","default":true}
];
export default languages